// API Configuration
const API_CONFIG = {
  // Main backend API
  BACKEND_BASE_URL: process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? 'http://localhost/api' : 'http://localhost:3001'),
  
  // Remote timelapse API
  TIMELAPSE_API_BASE_URL: process.env.REACT_APP_TIMELAPSE_API_URL || 'http://192.168.14.175:3001/api',
  
  // Environment detection
  IS_PRODUCTION: process.env.NODE_ENV === 'production',
  IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
  
  // API endpoints
  ENDPOINTS: {
    // Backend endpoints
    AUTH: '/api/auth',
    CAMERAS: '/api/cameras',
    PHOTOS: '/api/photos',
    TIMELAPSE_JOBS: '/api/timelapse-jobs',
    
    // Remote timelapse endpoints
    TIMELAPSE_HEALTH: '/health',
    TIMELAPSE_CAMERAS: '/cameras',
    TIMELAPSE_IMAGES: '/cameras/:camera/images',
    TIMELAPSE_CREATE: '/timelapse/create',
    TIMELAPSE_STATUS: '/timelapse/:jobId/status',
    TIMELAPSE_JOBS: '/timelapse/jobs',
    TIMELAPSE_DOWNLOAD: '/timelapse/:jobId/download',
    TIMELAPSE_DELETE: '/timelapse/:jobId'
  }
};

// Helper function to build API URLs
export const buildApiUrl = (endpoint, params = {}) => {
  let url = endpoint;
  
  // Replace path parameters
  Object.keys(params).forEach(key => {
    url = url.replace(`:${key}`, params[key]);
  });
  
  return url;
};

// Helper function to get full API URL
export const getApiUrl = (endpoint, params = {}, baseUrl = API_CONFIG.BACKEND_BASE_URL) => {
  const path = buildApiUrl(endpoint, params);
  return `${baseUrl}${path}`;
};

// Helper function to get timelapse API URL
export const getTimelapseApiUrl = (endpoint, params = {}) => {
  return getApiUrl(endpoint, params, API_CONFIG.TIMELAPSE_API_BASE_URL);
};

export default API_CONFIG;
